<template>
	<b-modal :id="modalData.id" :visible="modalData.visible" header-bg-variant="danger" header-text-variant="light" no-close-on-backdrop no-close-on-esc hide-header-close ok-only ok-variant="dark">
		<div slot="modal-title">Error</div>
		<b-container class="text-center">
			<b-row>
				<b-col class="text-justify" v-html="modalData.message"></b-col>
			</b-row>
		</b-container>
	</b-modal>
</template>

<script>
	export default
	{
		name: 'error-modal',
		props: [ 'modalData' ],
		data() { return {}; }
	}
</script>
